import * as types from '../mutation-types'
import {
  GET_STUDENT_ASSESSMENTS_LIST,
  GET_STUDENT_CURRENT_ASSESSMENTS,
  GET_STUDENT_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR,
  GET_STUDENT_MODULE_LIST_FOR_ASSESSMENT
} from '../action-types'
import server from '../server'
import axios from 'axios'

const state = {
  studentId: 0,
  selectedId: 0,
  allLoaded: false,
  assessmentsLoading: false,
  studentAssessments: [],
  currentStudentAssessments: [],
  functions: {
    moduleAssessment: 'ASSMODTAB',
    donutChartAndTodoList: 'ASSDNTTDL'
  },
  options: {
    enable: {
      enableModuleAssessment: 'ENBASSMOD',
      enableDonutChartAndTodoList: 'ENBDNTTDL'
    }
  },
  modules: [],
  selectedModule: ''
}

const mutations = {
  [types.SET_STUDENT_ASSESSMENTS_LIST] (state, list) {
    state.studentAssessments = list.map(assessment => {
      assessment.isOpen = false
      return assessment
    })
  },
  [types.SET_STUDENT_ASSESSMENTS_DETAILS] (state, list) {
    state.studentAssessments = list
  },
  [types.SET_STUDENT_ASSESSMENTS_LIST_LOADING] (state, {loading, currentPage, allLoaded}) {
    state.loadingList = loading
    if (loading) {
      state.currentPage = currentPage
      state.allLoaded = false
    } else {
      state.allLoaded = allLoaded
    }
  },
  [types.SET_STUDENT_ASSESSMENTS_SHOW_STATE] (state, id) {
    const assessment = state.studentAssessments.find(int => int.id === id)
    assessment.isOpen = !assessment.isOpen
  },
  [types.SET_STUDENT_ASSESSMENTS_LOADING] (state, loading) {
    state.assessmentsLoading = loading
  },
  [types.SOFT_RESET_ASSESSMENT_LIST] (state) {
    state.studentAssessments = []
  },
  [types.SET_STUDENT_CURRENT_ASSESSMENTS] (state, currentAssessments) {
    state.currentStudentAssessments = currentAssessments
  },
  [types.SET_ASSESSMENT_STUDENT_MODULES] (state, modules) {
    let list = []
    modules.forEach((module) => {
      list.push({
        text: `${module.moduleCode} - ${module.moduleDescription} - ${module.formattedAcademicYear}`,
        value: module.studentModuleId
      })
    })
    state.modules = list
  },
  [types.SET_ASSESSMENT_MODULE] (state, value) {
    state.selectedModule = value
  },
  [types.SET_SELECTED_MODULE_ID] (state, value) {
    state.selectedId = value
  },
  [types.SET_ASSESSMENT_MODULE_FROM_TAB] (state, module) {
    state.selectedModule = module.studentModuleId
    state.selectedId = module.id
    state.modules = [{
      text: `${module.moduleCode} - ${module.moduleName} - ${module.formattedAcademicYear}`,
      value: module.studentModuleId
    }]
  },
  [types.RESET_ASSESSMENT_STUDENT_MODULES] (state) {
    state.modules = []
    state.selectedModule = ''
  }
}

const actions = {
  [GET_STUDENT_ASSESSMENTS_LIST] ({commit, state}, studentId) {
    const actionData = { action: GET_STUDENT_ASSESSMENTS_LIST, data: studentId }
    commit(types.SOFT_RESET_ASSESSMENT_LIST)
    commit(types.SET_STUDENT_ASSESSMENTS_LOADING, true)
    server.getReplayable(`/core/student/${studentId}/get/assessment`, actionData)
      .then(res => {
        commit(types.SET_STUDENT_ASSESSMENTS_LIST, res.data)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
  },
  [GET_STUDENT_CURRENT_ASSESSMENTS] ({commit, state}, studentId) {
    const actionData = {
      action: GET_STUDENT_CURRENT_ASSESSMENTS, data: studentId
    }
    commit(types.SET_STUDENT_ASSESSMENTS_LOADING, true)
    return server.getReplayable(`/core/assessment/${studentId}/currentTerm`, actionData)
      .then(res => {
        commit(types.SET_STUDENT_CURRENT_ASSESSMENTS, res.data)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
  },
  [GET_STUDENT_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR] ({commit, state}, studentId) {
    const actionData = { action: GET_STUDENT_ASSESSMENTS_SUMMARY_BY_ACADEMIC_YEAR, data: studentId }
    commit(types.SOFT_RESET_ASSESSMENT_LIST)
    commit(types.SET_STUDENT_ASSESSMENTS_LOADING, true)
    let data = {moduleId: null, academicYear: null}
    if (state.selectedModule !== '') {
      const studentModuleId = state.selectedModule
      data = { studentModuleId: studentModuleId }
    }
    server.postReplayable(`/core/assessment/${studentId}/summaryByAcademicYear`, data, actionData)
      .then(res => {
        commit(types.SET_STUDENT_ASSESSMENTS_DETAILS, res.data)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
      .catch(error => {
        console.error(error)
        commit(types.SET_STUDENT_ASSESSMENTS_LOADING, false)
      })
  },
  [GET_STUDENT_MODULE_LIST_FOR_ASSESSMENT] ({rootState, commit}, {moduleSearch, studentId}) {
    if (moduleSearch.length < 3) return
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/attendance/match/${studentId}/${moduleSearch}`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData: { action: GET_STUDENT_MODULE_LIST_FOR_ASSESSMENT, data: moduleSearch }
    })
      .then((res) => {
        commit(types.SET_ASSESSMENT_STUDENT_MODULES, res.data)
      })
      .catch((err) => {
        console.error(err)
      })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/assessmentsModule.js